import { brazeDefaultLogEventFn, ga4DefaultLogEventFn, mParticleDefaultLogEventFn, branchDefaultLogEventFn, pushFn, fsDefaultLogEventFn, } from './DataFunctions';
export var DeepLinkProviders;
(function (DeepLinkProviders) {
    DeepLinkProviders["Firebase"] = "Firebase";
    DeepLinkProviders["Branch"] = "Branch";
    DeepLinkProviders["MParticleBranchKit"] = "MParticleBranchKit";
    DeepLinkProviders["Universal"] = "Universal";
})(DeepLinkProviders || (DeepLinkProviders = {}));
export var BrazeExternalIds;
(function (BrazeExternalIds) {
    BrazeExternalIds["MParticleId"] = "MParticleId";
    BrazeExternalIds["PhoneNumber"] = "PhoneNumber";
    BrazeExternalIds["CustomerId"] = "CustomerId";
})(BrazeExternalIds || (BrazeExternalIds = {}));
export var AnalyticsProviders;
(function (AnalyticsProviders) {
    AnalyticsProviders["GA4"] = "GA4";
    AnalyticsProviders["GTM"] = "GTM";
    AnalyticsProviders["Braze"] = "Braze";
    AnalyticsProviders["Branch"] = "Branch";
    AnalyticsProviders["MParticle"] = "MParticle";
    AnalyticsProviders["Facebook"] = "Facebook";
    AnalyticsProviders["FullStory"] = "FullStory";
})(AnalyticsProviders || (AnalyticsProviders = {}));
export class Provider {
    constructor(name, dataFunctions) {
        this.name = name;
        this.dataFunctions = dataFunctions;
    }
    static provider(name, dataFunctions) {
        return new Provider(name, dataFunctions);
    }
}
export class Event {
}
const { GA4, GTM, Braze, MParticle, Branch, Facebook, FullStory } = AnalyticsProviders;
export const DefaultProviders = {
    GA4Provider: new Provider(GA4, [ga4DefaultLogEventFn]),
    GTMProvider: new Provider(GTM, [pushFn]),
    BrazeProvider: new Provider(Braze, [brazeDefaultLogEventFn]),
    MParticleProvider: new Provider(MParticle, [mParticleDefaultLogEventFn]),
    BranchProvider: new Provider(Branch, [branchDefaultLogEventFn]),
    FacebookProvider: new Provider(Facebook, [ga4DefaultLogEventFn]),
    FSProvider: new Provider(FullStory, [fsDefaultLogEventFn]),
};
